<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Версии</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Версия https://mircity24.ru/
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="mircity" placeholder="example: 0.0.0" />
                            </CCol>
                            <!-- <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Версия https://prinocity.ru/
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="prinocity" placeholder="example: 0.0.0" />
                            </CCol> -->
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Версия приложения
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="mobile" placeholder="example: 0.0.0" />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardHeader>
                    <strong>Настройки окна принудительного обновления</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Версия пользователя, старше которой нужно показывать экран
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="force.minVersion" placeholder="example: 0.0.0" />
                            </CCol>
                            <template v-if="force.picture">
                                <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                                <CCol sm="7" class="col-form-label"><CImg
                                    :src="pictureUrl"
                                    class="m2"
                                    width="200" /></CCol>
                                <CCol sm="2" class="col-form-label">
                                    <CButton
                                        color="danger"
                                        class="ml-3"
                                        @click="deletePicture(force.picture)">Удалить</CButton>
                                </CCol>
                            </template>
                            <CCol
                                tag="label" 
                                sm="3"
                                class="col-form-label">
                                Изображение
                            </CCol>
                            <CCol sm="9">
                                <CInputFile
                                    ref="picture"
                                    horizontal
                                    @change="selectPicture"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Заголовок
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="force.title" placeholder="" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Подзаголововок
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="force.subtitle" placeholder="" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Текст на кнопке
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="force.buttonText" placeholder="" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Цвет текста кнопки
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="force.buttonColor" placeholder="" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Цвет кнопки
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="force.buttonBackground" placeholder="" />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton color="primary" @click="save()">Сохранить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { cilTrash } from '@coreui/icons';

    export default {
        name: 'VersionSettings',
        components: {},
        icons: {
            cilTrash,
        },

        data() {
            return {
                key: 'version',
                mircity: '',
                prinocity: '',
                mobile: '',
                force: {
                    minVersion: '',
                    picture: '',
                    title: '',
                    subtitle: '',
                    buttonText: '',
                    buttonColor: '',
                    buttonBackground: ''
                }
            };
        },

        computed: {
            pictureUrl() {
                if(this.force.picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.force.picture;
                } else {
                    return '';
                }
            },
        },

        mounted() {
            this.loadSettings();
        },

        methods: {
            selectPicture(FileList) {
                let formData = new FormData();
                formData.append('file', FileList[0]);
                Vue.axios.post('/files/upload', formData)
                    .then(resp => {
                        this.force.picture = resp.data.filename;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', `Ошибка загрузки файла.  \n\n${err.response.data.error}`);
                    });
            },
            deletePicture(url) {
                Vue.axios.delete(`/files/delete?filename=${url}`)
                    .then(() => {
                        this.force.picture = '';
                    })
                    .catch(err => {
                        this.$root.$emit('showError', `Ошибка удаления. \n\n${err.response.data.error}`);
                    });
            },
            save() {
                Vue.axios
                    .put('/settings/' + this.key, {
                        key: this.key,
                        value: {
                            mircity: this.mircity.trim(),
                            prinocity: this.prinocity.trim(),
                            mobile: this.mobile.trim(),
                            force: this.force,
                        },
                    })
                    .then(resp => {
                        this.mircity = resp.data.value.mircity;
                        this.prinocity = resp.data.value.prinocity;
                        this.mobile = resp.data.value.mobile;
                        this.force = {
                            ...this.force,
                            ...resp.data.value.force
                        };
                        this.$root.$emit('showAlert', 'Успешно');
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            loadSettings() {
                Vue.axios.get('/settings/' + this.key).then(resp => {
                    if (resp.data.value) {
                        this.mircity = resp.data.value.mircity;
                        this.prinocity = resp.data.value.prinocity;
                        this.mobile = resp.data.value.mobile;
                        this.force = {
                            ...this.force,
                            ...resp.data.value.force
                        };
                    }
                });
            },
        },
    };
</script>
